import type { ActivityType } from '../typings'
import { isAPIError, post } from '@user/store/services/crud'
import { baseUrl } from '../constants'
import { toast } from '@sales-center/components'
import { createActivityTypeActionCreator } from '../state'

export async function createActivityType(data: ActivityType) {
  const response = await post(baseUrl, data)
  const result = await response.json()

  if (!response.ok) {
    if (isAPIError(result.payload)) {
      toast.error(result.payload.Message)
    } else {
      toast.error('Failed to create Activity Type')
    }
    return createActivityTypeActionCreator()
  }

  return createActivityTypeActionCreator(result)
}
